var map = {
	"./addDisposal.svg": 1218,
	"./addFavor.svg": 1219,
	"./addMonitor.svg": 1220,
	"./addOpinion.svg": 1221,
	"./addTheAttention.svg": 1222,
	"./delete.svg": 1223,
	"./export.svg": 1224,
	"./promptIcon.svg": 1225,
	"./removeDisposal.svg": 1226,
	"./removeDisposal1.svg": 1227,
	"./removeFavor.svg": 1228,
	"./removeMonitor.svg": 1229,
	"./unfollow.svg": 1230,
	"./upload.svg": 1231
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1217;